module.exports = __webpack_public_path__ + "img/search.18694616.svg";